
import React from 'react'
//import makeStyles from '@material-ui/core/styles/makeStyles'

export default function ProfileIcon(props) {
    const { style, color } = props;
    //const classes = useStyles(props)()

    return(
        <svg fill={color} style={style} width="23" height="23" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.322 22.645C5.07 22.645 0 17.575 0 11.322C0 5.068 5.07 0 11.322 0C17.575 0 22.644 5.068 22.644 11.322C22.644 17.575 17.576 22.645 11.322 22.645ZM10.631 4.117C10.562 4.117 10.492 4.12 10.423 4.125C9.042 4.24 8.017 5.452 8.131 6.834L8.224 7.957C8.359 9.568 9.705 10.808 11.322 10.808C12.939 10.808 14.285 9.569 14.419 7.957L14.513 6.834C14.519 6.765 14.523 6.695 14.523 6.626C14.523 5.239 13.398 4.117 12.013 4.117H10.631ZM17.268 18.424L17.993 15.171C18.066 14.842 17.936 14.504 17.663 14.308C15.577 12.819 13.458 12.062 11.323 12.062C9.188 12.062 7.069 12.819 4.982 14.308C4.71 14.504 4.58 14.842 4.653 15.171L5.378 18.424C6.986 19.774 9.06 20.586 11.323 20.586C13.586 20.586 15.66 19.773 17.268 18.424Z" />
        </svg>
    )
}

/*const useStyles = props => makeStyles((theme) => ({
   
}));*/